import { render } from "./MemberDetailsPage.vue?vue&type=template&id=6c887fdc&scoped=true"
import script from "./MemberDetailsPage.vue?vue&type=script&lang=js"
export * from "./MemberDetailsPage.vue?vue&type=script&lang=js"

import "./MemberDetailsPage.vue?vue&type=style&index=0&id=6c887fdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c887fdc"]])

export default __exports__